import { createContext } from 'react';
import type { AuthState, AuthSource } from './types';

export interface AuthContextValue extends AuthState, Pick<AuthSource, 'signInWithEmail' | 'signInWithApple' | 'resetPassword' | 'register' | 'refresh'> {
  signInWithGoogle: () => Promise<void>;
  signOut: () => Promise<void>;
}

/** Contexto separado del provider para no romper el fast-refresh de Vite. */
export const AuthContext = createContext<AuthContextValue | null>(null);
